/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Card,
  Table,
  Button,
  Space,
  Input,
  Popconfirm,
  Tag,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { getAPI, postAPI, displayMessage } from "../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../constants/messages";
import { KITCHEN_PR_LIST, KITCHEN_PR_DELETE } from "../../constants/api";

function KitchenPRTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);

    const successFn = (res) => {
      if (res.status === true) {
        const formatted = res.data.map((row, index) => ({
          key: index,
          ID: index + 1,
          Date: dayjs(row.date).format("DD MMM YYYY"),
          RequestedBy: row.requested_by,
          Priority:
            row.priority === "Urgent" ? (
              <Tag color="red">{row.priority}</Tag>
            ) : (
              <Tag color="blue">{row.priority}</Tag>
            ),
          Status: (
            <Tag
              color={
                row.status === "Pending"
                  ? "orange"
                  : row.status === "Approved"
                    ? "green"
                    : row.status === "Reject"
                      ? "red"
                      : "purple"
              }
            >
              {row.status}
            </Tag>
          ),
          Action: (
            <Space>
              <Button
                size="small"
                onClick={() =>
                  navigate("/kitchen/purchase-request/view/" + row.id)
                }
              >
                View
              </Button>

              {row.status === "Approved" && (
                <Button
                  size="small"
                  type="default"
                  onClick={() =>
                    navigate("/kitchen/purchase/add", {
                      state: { pr_id: row.id },
                    })
                  }
                >
                  Create Purchase
                </Button>
              )}

              {/* <Popconfirm
                title="Delete Purchase Request"
                description="Are you sure to delete this PR?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button size="small" danger>
                  Delete
                </Button>
              </Popconfirm> */}
            </Space>
          ),
        }));

        setState(formatted);
        setFilteredState(formatted);
      } else {
        setState([]);
        setFilteredState([]);
      }
      setLoading(false);
    };

    const errorFn = () => {
      setLoading(false);
      setState([]);
      setFilteredState([]);
    };

    getAPI(KITCHEN_PR_LIST, successFn, errorFn, {});
  };

  const deleteData = (id) => {
    setLoading(true);

    postAPI(
      KITCHEN_PR_DELETE,
      { pr_id: id },
      (res) => {
        if (res.status === true) {
          displayMessage(SUCCESS_MESSAGE, res.message);
          getList();
        } else {
          setLoading(false);
          displayMessage(ERROR_MSG_TYPE, res.message);
        }
      },
      () => {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, "Unable to delete PR");
      },
    );
  };

  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = state.filter((row) =>
      row.RequestedBy.toLowerCase().includes(value.toLowerCase()),
    );
    setFilteredState(filtered);
  };

  const columns = [
    { title: "S.No", dataIndex: "ID", width: 60 },
    { title: "Date", dataIndex: "Date", width: 150 },
    { title: "Requested By", dataIndex: "RequestedBy", width: 200 },
    { title: "Priority", dataIndex: "Priority", width: 120 },
    { title: "Status", dataIndex: "Status", width: 120 },
    { title: "Action", dataIndex: "Action", width: 180 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Purchase Requests"
          bordered
          extra={
            <Space>
              <Input
                placeholder="Search by requester"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 250 }}
              />
              <Button
                type="primary"
                onClick={() => navigate("/kitchen/purchase-request/add")}
              >
                Add PR <PlusOutlined />
              </Button>
            </Space>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 900 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenPRTable;
